import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
`;

const Placeholder = styled.div`
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
`;

const BodyText = styled.div`
  color: rgba(255, 255, 255, 0.55);
  font-size: 12px;
  margin-top: 8px;
`;

export default function TasksModule() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // TODO: Fetch actual tasks from API
    // For now, show placeholder
    setLoading(false);
  }, []);

  if (loading) {
    return <Placeholder>Loading tasks...</Placeholder>;
  }

  if (tasks.length === 0) {
    return (
      <Container>
        <BodyText>Pulling from tasks app</BodyText>
      </Container>
    );
  }

  return (
    <Container>
      <BodyText>Pulling from tasks app</BodyText>
    </Container>
  );
}

